import { handleResponse, handleError, getProductApiUrl, queryValue } from "./apiUtils";
import getRequestOptions from './authorizationUtils';
import axios from 'axios';

// Served by the tenant's sugar instance (module Products), not by the ProductRegister
// azure function app any more. The request and response shapes are unchanged.

export function ReadProductsRegister(filter, sort, page, productGroup, unit, cancelToken) {
    const options = getRequestOptions(cancelToken);
    return axios.get(getProductApiUrl() + `JSONProductRegisterGetAll&filter=${queryValue(filter)}&sort=${queryValue(sort)}&page=${queryValue(page)}&productGroup=${queryValue(productGroup)}&productUnit=${queryValue(unit)}`, options)
        .then(handleResponse)
        .catch(handleError);
}

export function ReadProductsMassive(cancelToken) {
    const options = getRequestOptions(cancelToken);
    return axios.get(getProductApiUrl() + `JSONProductRegisterGetMass`, options)
        .then(handleResponse)
        .catch(handleError);
}


export function ReadProductRegister(id) {
    const options = getRequestOptions();
    return axios.get(getProductApiUrl() + `JSONProductRegisterGet&id=${queryValue(id)}`, options)
        .then(handleResponse)
        .catch(handleError);
  }

export function updateProductRegister(productRegister) {
    const options = getRequestOptions();
    return axios.post(getProductApiUrl() + `JSONProductRegisterPost`, productRegister, options)
        .then(handleResponse)
        .catch(handleError);
}
